module.exports = __webpack_public_path__ + "img/Warranty 2.74c67085.svg";